<template>
    <div id="notification-container">
        <b-alert :variant="variant"
          v-model="showAlert"
          class="row"
          id="notification-bar">
          {{message}}
      </b-alert>
    </div>
</template>

<script>
export default {
  props: {
    message: {
      required: true,
      type: String
    },
    variant: {
      requited: true,
      type: String
    },
    showAlert: {
      required: true,
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
#notification-bar{
  margin-top:1rem;
}
</style>
